const moment = require('moment');
const { default: AggConstants } = require('../../constants/AggConstants');
const { default: TipoAtributo } = require('../../constants/TipoAtributo');
const { SPLIT_CHAR_SPECIAL } = require('../../constants/Split');
const FiltroConstants = require('../../constants/FiltroConstants').default;
const Atributos = require('../../common/Atributos');
module.exports = {
    cubo: 'cubo_fichas',
    title: 'Série Histórica',
    primeiraConsultaAutomatica: true,
    atributosSelecionados: [
        Atributos.F_ATENDIMENTO_DATA_ANO,
        Atributos.F_CABECALHO_NOME_CENTRO,
        Atributos.F_SOLICITANTE_ESTADO_SIGLA,
        Atributos.F_CABECALHO_TIPO_FICHA,
        Atributos.F_AGENTE_GRUPO_DESCRICAO_ASSOC,
        // Atributos.QNT, // Sempre colocar o último atributo como métrica.
    ],
    medidas: [Atributos.F_ACOMPANHAMENTO_QNT_ACOMPANHAMENTOS],
    nextPage: '/solicitante',
    // backPage: '',
    charts: [
        {
            title: 'Número de Casos Atendidos',
            type: 'CardAbsoluteChart',
            layout: 'esmeralda',
            selectDimensions: [Atributos.QNT],
            filters: [],
            transformations: [],
        },
        {
            title: 'Número de Acompanhamentos',
            type: 'CardAbsoluteChart',
            layout: 'moderno',
            selectDimensions: [Atributos.F_ACOMPANHAMENTO_QNT_ACOMPANHAMENTOS],
            // groupByV2: {
            //     alias: 'total_pacientes_lesoes',
            //     attribute: Atributos.F_ACOMPANHAMENTO_QNT_ACOMPANHAMENTOS,
            //     operation: 'sum', // 'sum' | 'distinct-count' | max | min | avg
            // },
            filters: [],
            transformations: [],
        },
        {
            title: 'Exposição Vítima Humana',
            type: 'CardPercentage2Chart',
            layout: '#ff0000',
            selectDimensions: [Atributos.F_CABECALHO_TIPO_FICHA, Atributos.QNT],
            having: ['Humana'],
            filters: [],
            transformations: [],
        },
        {
            title: 'Exposição Vítima Animal',
            type: 'CardPercentage2Chart',
            layout: '#9966ff',
            selectDimensions: [Atributos.F_CABECALHO_TIPO_FICHA, Atributos.QNT],
            having: ['Animal'],
            filters: [],
            transformations: [],
        },
        {
            title: 'Informação',
            type: 'CardPercentage2Chart',
            selectDimensions: [Atributos.F_CABECALHO_TIPO_FICHA, Atributos.QNT],
            having: ['Informacão'],
            filters: [],
            transformations: [],
        },
        {
            title: 'SÉRIE HISTÓRICA DOS CASOS ATENDIDOS',
            description: 'EVOLUÇÃO ANUAL DOS CASOS DE INTOXICAÇÃO ATENDIDOS PELOS CENTROS DE INFORMAÇÃO E ASSISTÊNCIA TOXICOLÓGICA DO BRASIL.',
            type: 'ApexLineChart',
            w: 2,
            selectDimensions: [Atributos.F_ATENDIMENTO_DATA_ANO, Atributos.QNT],
            filters: [],
            transformations: [],
            uiConfig: {
                enableAnimation: true,
            },
        },
        {
            title: 'CASOS ATENDIDOS NOTIFICADOS NO SISTEMA DATATOX BI DE ACORDO COM OS CENTROS E O ANO',
            description: 'CASOS ATENDIDOS NOTIFICADOS NO SISTEMA DATATOX BI DE ACORDO COM OS CENTROS E O ANO.',
            type: 'Pivottable',
            h: '500px',
            w: 6,
            // legend: 'Nota: Esta tabela mostra dados consolidados. Valores em branco indicam ausência de dados.',
            layout: 'fullComLegendas',
            headers: ['Ano', 'Centro', 'Quantidade'],
            selectDimensions: [Atributos.F_ATENDIMENTO_DATA_ANO, Atributos.F_CABECALHO_NOME_CENTRO, Atributos.QNT],
            rows: ['Centro'],
            rowOrder: 'value_z_to_a',
            enablePercentage: true,
            aggregatorList: [
                {
                    aggregatorName: 'Integer Sum',
                    aggTitle: 'Total',
                    vals: ['Quantidade'],
                },
                {
                    aggregatorName: 'Sum as Fraction of Total',
                    aggTitle: '%',
                    vals: ['Quantidade'],
                },
            ],
            aggregatorName: 'Integer Sum',
            vals: ['Quantidade'],
            cols: ['Ano'],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_CABECALHO_NOME_CENTRO],
                    transformation: (value) => {
                        if (value === 'Não preenchido')
                            return 'Ignorado';
                        if (value === 'Ignorado')
                            return 'Ignorado';
                        return value;
                    },
                },
            ],
        },
        {
            title: 'NÚMERO DE ACOMPANHAMENTOS DOS CASOS ATENDIDOS NOTIFICADOS NO SISTEMA DATATOX BI DE ACORDO COM OS CENTROS E O ANO',
            description: 'EVOLUÇÃO ANUAL DOS ACOMPANHAMENTOS REALIZADOS PELOS CENTROS DE INFORMAÇÃO E ASSISTÊNCIA TOXICOLÓGICA DO BRASIL.',
            type: 'Pivottable',
            h: '500px',
            w: 6,
            // legend: 'Nota: Esta tabela mostra dados consolidados. Valores em branco indicam ausência de dados.',
            layout: 'fullComLegendas',
            headers: ['Ano', 'Centro', 'Quantidade'],
            selectDimensions: [Atributos.F_ATENDIMENTO_DATA_ANO, Atributos.F_CABECALHO_NOME_CENTRO, Atributos.F_ACOMPANHAMENTO_QNT_ACOMPANHAMENTOS],
            rows: ['Centro'],
            rowOrder: 'value_z_to_a',
            enablePercentage: true,
            aggregatorList: [
                {
                    aggregatorName: 'Integer Sum',
                    aggTitle: 'Total',
                    vals: ['Quantidade'],
                },
                {
                    aggregatorName: 'Sum as Fraction of Total',
                    aggTitle: '%',
                    vals: ['Quantidade'],
                },
            ],
            aggregatorName: 'Integer Sum',
            vals: ['Quantidade'],
            cols: ['Ano'],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_CABECALHO_NOME_CENTRO],
                    transformation: (value) => {
                        if (value === 'Não preenchido')
                            return 'Ignorado';
                        if (value === 'Ignorado')
                            return 'Ignorado';
                        return value;
                    },
                },
            ],
        },
        {
            title: 'TIPO DE VÍTIMA/SOLICITAÇÃO',
            description: 'TIPO DE VÍTIMA/SOLICITAÇÃO.',
            type: 'Pivottable',
            h: '450px',
            headers: ['Ano', 'Tipo de Vítima/Solicitação', 'Quantidade'],
            selectDimensions: [Atributos.F_ATENDIMENTO_DATA_ANO, Atributos.F_CABECALHO_TIPO_FICHA, Atributos.QNT],
            rows: ['Ano'],
            rowOrder: 'key_a_to_z',
            // aggregatorName: 'Integer Sum',
            aggregatorList: [
                {
                    aggregatorName: 'Integer Sum',
                    aggTitle: 'Total',
                    vals: ['Quantidade'],
                },
                {
                    aggregatorName: 'Sum as Fraction of Total',
                    aggTitle: '%',
                    vals: ['Quantidade'],
                },
            ],
            enablePercentage: true,
            vals: ['Quantidade'],
            cols: ['Tipo de Vítima/Solicitação'],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_CABECALHO_TIPO_FICHA],
                    transformation: (value) => {
                        if (value === 'Humana')
                            return ' Humana';
                        return value;
                    },
                },
            ],
        },
        {
            title: 'GRUPO DE AGENTES',
            description: 'GRUPO DE AGENTES.',
            type: 'Pivottable',
            h: '450px',
            headers: ['Ano', 'Grupo (Isolado/Associação)', 'Quantidade'],
            selectDimensions: [Atributos.F_ATENDIMENTO_DATA_ANO, Atributos.F_AGENTE_GRUPO_DESCRICAO_ASSOC, Atributos.QNT],
            rows: ['Grupo (Isolado/Associação)'],
            rowOrder: 'value_z_to_a',
            enablePercentage: true,
            aggregatorList: [
                {
                    aggregatorName: 'Integer Sum',
                    aggTitle: 'Total',
                    vals: ['Quantidade'],
                },
                {
                    aggregatorName: 'Sum as Fraction of Total',
                    aggTitle: '%',
                    vals: ['Quantidade'],
                },
            ],
            aggregatorName: 'Integer Sum',
            vals: ['Quantidade'],
            cols: ['Ano'],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_AGENTE_GRUPO_DESCRICAO_ASSOC],
                    transformation: (value) => {
                        if (value === 'Não preenchido')
                            return 'Ignorado';
                        if (value === 'Ignorado')
                            return 'Ignorado';
                        return value;
                    },
                },
            ],
        },
        // {
        //     title: 'ESTADO DO SOLICITANTE',
        //     description: 'ESTADO DO SOLICITANTE.',
        //     type: 'MapChart',
        //     metaAtributos: [
        //         {
        //             atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
        //             rotulo: 'UF Solicitante',
        //             tipo: TipoAtributo.TEXTO_GEO_UF,
        //         },
        //         // {
        //         //     atributo: 'f_exposicao_codigo_ibge',
        //         //     rotulo: 'Cidade',
        //         //     tipo: TipoAtributo.TEXTO_GEO_COD_IBGE,
        //         // },
        //         {
        //             atributo: Atributos.QNT,
        //             rotulo: 'Quantidade',
        //             tipo: TipoAtributo.NUMERICO_INTEIRO,
        //         },
        //     ],
        //     selectDimensions: [Atributos.F_SOLICITANTE_ESTADO_SIGLA, Atributos.QNT],
        //     filters: [],
        //     transformations: [],
        // },
    ],
    metaAtributos: [
        {
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            grupo: 'Nome do centro',
            rotulo: 'Nome do centro',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            grupo: 'Ano de atendimento',
            rotulo: 'Ano de atendimento',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            grupo: 'Tipo de Ficha',
            rotulo: 'Tipo de Ficha',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            grupo: 'UF Solicitante',
            rotulo: 'UF Solicitante',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.GRUPO,
            grupo: 'Grupo de agentes',
            rotulo: 'Grupo de agentes',
            tipo: 'TEXTO',
        },
    ],
    preFiltrosServer: [
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            tipoComponente: 'IN_SELECT',
            valor: ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026'].join(FiltroConstants.SPLIT_VALUES),
        },
    ],
    filtros: [
        {
            key: 1,
            size: 2,
            disabled: true,
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            rotulo: 'Ano do atendimento',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 2,
            size: 2,
            disabled: true,
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            rotulo: 'Tipo de vítima/solicitação',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 3,
            size: 2,
            disabled: true,
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            rotulo: 'UF Solicitante',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 4,
            size: 2,
            disabled: false,
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            rotulo: 'Nome do centro',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 5,
            size: 2,
            disabled: false,
            atributo: Atributos.GRUPO,
            rotulo: 'Grupo de agentes',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
    ],
};
